import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction"
import { setCurrentTv } from "../../Redux/Reducers/tvRemoteReducer";

    
    
    
export const getToken = (dispatch, roomRemoteDetails, currentTv) => {
    if(!roomRemoteDetails){
        return null
    }
    
    let token = null
    if (roomRemoteDetails.length > 0) {
        if (!currentTv?.remoteSessionToken) {
            if (roomRemoteDetails.length === 1) {
                dispatch(setCurrentTv(roomRemoteDetails[0]));
                token = roomRemoteDetails[0].remoteSessionToken
            } else {
                // this.props.popupOpenClose(true, "Please select your TV In TV section.");
            }
        } else {
            token = currentTv?.remoteSessionToken
            console.log('getToken else', token);
        }
    } else {
        //this.props.popupOpenClose(true, "No TVs to control are found.");
        console.log("No TVs to control are found");

        dispatch(setRenderFlashMessage(true, {type: "danger", message: "TV is offline"}));
    }
    console.log('getToken', token);
    return token
}